// extracted by mini-css-extract-plugin
module.exports = {"ratingContainer":"style_ratingContainer__2YU5E","ratingValue":"style_ratingValue__3YbGr","ratingImage":"style_ratingImage__519op"};